/* eslint-disable no-console */
import { call, put, takeLeading, all, delay } from 'redux-saga/effects'

import handleError from 'models/handle-error'
import { REQUEST_RESOLVE_MINIMUM_TIME_MS } from 'resources'
import api from './api'
import actions from './actions'

function* fetchTransactions() {
  try {
    const result = yield all({
      request: call(api.fetchTransactions),
      delay: delay(REQUEST_RESOLVE_MINIMUM_TIME_MS),
    })
    yield put(actions.fetchTransactions.success(result.request))
  } catch (error) {
    console.error('[Transactions] fetchTransactions:', error)
    yield put(handleError(error))
    yield put(actions.fetchTransactions.failure())
  }
}

function* claimPendingTransactions({ payload }) {
  const { callback } = payload

  let isSuccess = false
  try {
    const result = yield call(api.claimPendingTransactions)
    yield put(actions.claimPendingTransactions.success(result))
    isSuccess = true
  } catch (error) {
    console.error('[Transactions] claimPendingTransactions:', error)
    yield put(actions.claimPendingTransactions.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

export default function* main() {
  yield takeLeading(actions.fetchTransactions.INIT_TYPE, fetchTransactions)
  yield takeLeading(actions.claimPendingTransactions.INIT_TYPE, claimPendingTransactions)
}
